// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#header.header-page-payment-failed .logo-container {
  justify-content: center;
}

.page-payment-failed {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.page-payment-failed .title {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;
  margin-bottom: 32px;
}

.page-payment-failed .title svg {
  height: 64px;
  width: 64px;
  margin-bottom: 24px;
}

.page-payment-failed .title .text {
  color: var(--red);
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.48px;

  margin: 0 auto;
  text-align: center;
}

.page-payment-failed .error-message {
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.02em;
  padding: 0 30px;
  text-align: center;
}

.page-payment-failed .button-container {
  position: fixed;
  bottom: 45px;
  width: 327px;
  border-radius: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/orgfit/pilates-3-ltp/css/pages/payment-failed.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;;EAEtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":["#header.header-page-payment-failed .logo-container {\n  justify-content: center;\n}\n\n.page-payment-failed {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.page-payment-failed .title {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 10vh;\n  margin-bottom: 32px;\n}\n\n.page-payment-failed .title svg {\n  height: 64px;\n  width: 64px;\n  margin-bottom: 24px;\n}\n\n.page-payment-failed .title .text {\n  color: var(--red);\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 36px;\n  letter-spacing: 0.48px;\n\n  margin: 0 auto;\n  text-align: center;\n}\n\n.page-payment-failed .error-message {\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.02em;\n  padding: 0 30px;\n  text-align: center;\n}\n\n.page-payment-failed .button-container {\n  position: fixed;\n  bottom: 45px;\n  width: 327px;\n  border-radius: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
